import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-visitmediche',
  templateUrl: './visitmediche.component.html',
  styleUrls: ['./visitmediche.component.scss']
})
export class VisitmedicheComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
